import CountryRestriction from "src/static/Restriction/country_restriction";

const Restriction = () => <CountryRestriction />;

export default Restriction;
